<div [grid]="34"
     [gridColumnGap]="['0px','15px','15px','20px'][isUpsellPreviewVariant ? 0 : client.sizeId]">
    <ng-container *ifSize="'XLM'">
        <ng-container *ngTemplateOutlet="mediaCarousel"></ng-container>
    </ng-container>

    <ng-container *ifSize="'S'">
        <ng-container *ngTemplateOutlet="mediaCarousel"></ng-container>
    </ng-container>
</div>

<!-- lightbox, remove for upsell preview, we cannot have two lightboxzes on same page -->
@if(!isUpsellPreviewVariant){
<photoswipe-lightbox [photoswipeOptions]="photoswipeOptions"
                     (photoswipeStateChange)="onPhotoswipeStateChange($event)">
    <ng-template #photoswipeThumbnailTpl
                 let-item
                 let-i="index"
                 let-photoswipe="photoswipe">
        @if (item.source) {
        <div class="pos-relative bg-col-5 pswp__thumb"
             [class.is-active]="item === photoswipe?.currItem"
             (click)="photoswipe?.goTo(i)">
            <img class="fill"
                 [image]="item.source"
                 [attr.alt]="source.data.name">
        </div>
        }
    </ng-template>

    <ng-template #photoswipeIconCloseTpl>
        <i class="icon-arrow-left inline-block va-m"
           aria-hidden="true"></i>
        <span class="inline-block overflow-hidden no-wrap"
              translate>&nbsp;&nbsp;Back to item</span>
    </ng-template>

    <ng-template #photoswipeIconPrevTpl></ng-template>

    <ng-template #photoswipeIconNextTpl></ng-template>
</photoswipe-lightbox>
}

<ng-template #mediaCarousel>
    <!-- thumbnails -->
    @if(!client.isS && !isUpsellPreviewVariant){
    <div [gridColumn]="(client.isL ? 7 : 6)">

        <div class="w-12 height-100">
            <!-- slides -->
            <carousel class="product-gallery product-gallery-thumbs"
                      [direction]="'vertical'"
                      [slidesPerView]="client.isL ? 3.9 : 4.7"
                      [spaceBetween]="20"
                      [autoHeight]="true"
                      [navigation]="media?.length > 4">
                @for (item of media; track item; let index = $index) {
                <ng-template swiperSlide>
                    <div class="ratio-1-1 overflow-hidden cursor-pointer product-gallery-image"
                         (click)="slideTo(index)">
                        <local-shell />
                        <img class="rf"
                             [image]="item.image">
                    </div>
                </ng-template>
                }
            </carousel>
        </div>

    </div>
    }

    <!-- main gallery -->
    <div class="pos-relative _product-gallery-wrapper"
         [gridColumn]="client.isS || isUpsellPreviewVariant ? 34 : (client.isL ? 27 : 28)">
        <div class="w-12 ratio-1-1 product-gallery">
            <div class="fill overflow-hidden">
                <local-shell />
            </div>
            <carousel class="fill-x fill-l fill-m fill-s"
                      [pagination]="{clickable: true}"
                      [slidesPerView]="1"
                      [loop]="false"
                      [effect]="'fade'"
                      [fadeEffect]="{ crossFade: true }"
                      [navigation]="{
                            nextEl: '.carousel-next-' + uid,
                            prevEl: '.carousel-prev-' + uid
                          }"
                      (afterInit)="setCarousel($event)">
                @for (item of media; track item; let i = $index; let isFirst = $first) {
                <ng-template swiperSlide>
                    <!-- photoswiper -->
                    @if (carousel) {
                    <div class="ratio-1-1 overflow-hidden"
                         [ngClass]="['photoswipe-galleryuid-' + source.data.id, !item.video ? 'product-image-gallery-container' : '']">
                        <local-shell />
                        <!-- img -->
                        @if (item && !item.video) {
                        <img class="rf bg-col-w"
                             [image]="item.image"
                             [attr.alt]="getImageAltText(item.alt_text)"
                             [photoswipe]="item.image"
                             [photoswipeUid]="item.image"
                             [photoswipeOptions]="{
                                            index: i,
                                            galleryUID: source.data.id
                                        }"
                             [attr.loading]="isFirst ? 'eager' : 'lazy'"
                             [attr.fetchpriority]="isFirst ? 'high' : 'low'">
                        }
                        <!-- video -->
                        @if (item.video) {
                        <vimeo-player [video-url]="item.video"
                                      [background]="!showVideoControlPanel(item)"
                                      class="bg-col-w"
                                      [autoplay-in-viewport]="true"
                                      [loop]="true"
                                      [controls]="showVideoControlPanel(item)">
                        </vimeo-player>

                        @if (client.isS) {
                        <button class="pos-absolute top-50 left-0 swiper-button-prev"
                                [class.disabled]="i - 1 < 0"
                                (click)="slideTo(i - 1)"
                                type="button"
                                [attr.aria-label]="'Previous slide' | translate">
                        </button>
                        <button class="pos-absolute top-50 right-0 swiper-button-next"
                                [class.disabled]="i + 1 >= media.length"
                                (click)="slideTo(i + 1)"
                                type="button"
                                [attr.aria-label]="'Next slide' | translate">
                        </button>
                        }
                        }
                    </div>
                    }
                </ng-template>
                }
            </carousel>
            <!-- is new label -->
            @if (source?.isNew) {
            <div class="flex z-2 pos-absolute top-0 right-0">

                <!-- in stock label -->
                @if (inStockLabel) {
                <p class="pdp-label col-w m-r-2"
                   [ngStyle]="{'background-color': inStockLabel.color || 'black'}">
                    <span>{{ inStockLabel.label }}</span>
                </p>
                }
                <p class="bg-col-11 pdp-label col-w">
                    <span>{{ 'New In' | translate }}</span>
                </p>
            </div>
            }

            <!-- default label -->
            @if (labels?.length && !source?.isNew) {
            <div class="flex z-2 pos-absolute top-0 right-0">
                @for (label of labels; track label; let isFirst = $first) {
                <p class="bg-col-2 pdp-label col-w"
                   [class.m-l-2]="!isFirst"
                   [ngStyle]="{'background-color': label.color || 'black'}">
                    <span>{{label.label}}</span>
                </p>
                }
            </div>
            }
        </div>
        @if (!client.isS) {
        <button class="pos-absolute top-50 left-0 swiper-button-prev"
                [ngClass]="'carousel-prev-' + uid"
                type="button"
                [attr.aria-label]="'Previous slide' | translate">
        </button>
        <button class="pos-absolute top-50 right-0 swiper-button-next"
                [ngClass]="'carousel-next-' + uid"
                type="button"
                [attr.aria-label]="'Next slide' | translate">
        </button>
        }
    </div>
</ng-template>
